import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { LoadingOverlayComponent, CardComponent, SelectedPanelHeaderComponent } from '@microsec/components';
import { BaseComponent } from '@ids-components';
import { DividerModule } from 'primeng/divider';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { ReportOverviewComponent } from './report-overview/report-overview.component';
import { REPORT_STATUSES } from '@ids-constants';
import { TooltipModule } from 'primeng/tooltip';
import { ReportService } from '@ids-services';

@Component({
  selector: 'app-report-details',
  templateUrl: './report-details.component.html',
  styleUrls: ['./report-details.component.scss'],
  imports: [
    CommonModule,
    TabsModule,
    ButtonModule,
    DividerModule,
    TooltipModule,
    CardComponent,
    SelectedPanelHeaderComponent,
    LoadingOverlayComponent,
    ReportOverviewComponent,
  ],
})
export class ReportDetailsComponent extends BaseComponent implements AfterViewInit {
  @Input() isLoading = true;
  _report: any = {};

  isReportLoading = false;

  get report() {
    return this._report;
  }

  @Input() set report(value: any) {
    this.isReportLoading = true;
    this.reportSrv.getReport(value.id).subscribe((res) => {
      this._report = {
        ...value,
        ...res,
        reportFilters: (res.report_filters || []).reduce((obj: { [key: string]: any }, filter: any) => {
          const filters = Object.keys(filter)
            .filter((key) => key !== 'data_source' && !!filter[key])
            .filter((key) => !Array.isArray(filter[key]) || (!!Array.isArray(filter[key]) && !!filter[key].length))
            .reduce(
              (a, key) => ({
                ...a,
                [key]: !!Array.isArray(filter[key]) ? filter[key].map((v: any) => v.data || v) : filter[key].data || filter[key],
              }),
              {},
            );
          return { ...obj, [filter.data_source]: filters };
        }, {}),
      };
      this.isReportLoading = false;
    });
  }
  @Input() zones: any[] = [];
  @Input() assessments: any[] = [];
  @Input() devices: any[] = [];
  @Input() connections: any[] = [];
  @Input() reportFilters: any = {};

  @Output() hideDetailsPanelEvent = new EventEmitter<any>();
  @Output() previewReportEvent = new EventEmitter<any>();
  @Output() setDownloadMenuEvent = new EventEmitter<any>();
  @Output() openReportFormEvent = new EventEmitter<any>();
  @Output() goToAssessmentEvent = new EventEmitter<any>();
  @Output() openDeleteConfirmationEvent = new EventEmitter<any>();

  REPORT_STATUSES = REPORT_STATUSES;

  constructor(private reportSrv: ReportService) {
    super();
  }

  async ngAfterViewInit() {
    await this.prepareConfigs();
  }

  hideDetailsPanel() {
    this.hideDetailsPanelEvent.emit();
  }

  previewReport(report: any) {
    this.previewReportEvent.emit(report);
  }

  setDownloadMenu(event: any, report: any) {
    this.setDownloadMenuEvent.emit({ event, report });
  }

  openReportForm(report: any) {
    this.openReportFormEvent.emit(report);
  }

  goToAssessment(assessmentId: any) {
    this.goToAssessmentEvent.emit(assessmentId);
  }

  openDeleteConfirmation(reports: any[] = []) {
    this.openDeleteConfirmationEvent.emit(reports);
  }
}
